import styled from 'styled-components';
import { stringToColour } from '../../utils/style/colors';

export interface IProps {
  children: React.ReactNode;
  content: string;
  color?: string;
  isInline?: boolean;
}

const Container = styled.div<{ isInline?: boolean }>`
  border-inline-start: 4px solid ${(props) => props.color};
  padding-inline-start: 0.25rem;
  margin-bottom: 0.5rem;
  color: ${(props) => props.color};
  display: ${(props) => (props.isInline ? 'inline-block' : 'auto')};
`;

const BorderBadge: React.FC<IProps> = ({
  children,
  color,
  content,
  isInline,
}) => {
  return (
    <Container
      color={color ?? stringToColour(content, 1, false)}
      isInline={isInline}
    >
      {children}
    </Container>
  );
};

export default BorderBadge;
